const getCurrentPosition = () => {
	return new Promise(async (resolve, reject) => {
		let position = await new Promise((resolve2) => {
			if (window.location.hostname.includes(".wwdev2")) {
				position = {
					latitude: 52.378276,
					longitude: 5.771701
				};
				resolve2(position);
				return;
			}

			navigator.geolocation.getCurrentPosition(async (result) => {
				position = {
					latitude: result.coords.latitude,
					longitude: result.coords.longitude,
				};
				resolve2(position);
			}, error => {
				console.log(error);
				console.warn("Geolocatie geweigerd of mislukt:", error);
				resolve(null);
			});
		});

		if(!position) {
			resolve(null);
		}

		try {
			let params = new URLSearchParams(position);
			const response = await fetch(`/get-formatted-address?${params.toString()}`);
			const data = await response.json();
			resolve(data);
		} catch (err) {
			console.error("Fout bij ophalen adres:", err);
			resolve(null);
		}
	});
}

export default getCurrentPosition;